<template>
    <div class="time-window">
        <label v-if="showLabels" class="col-xs-3">{{ $t('sensors.residentProfilesTab.timeWindow') }}</label>
        <div class="col-xs-4 time-wrapper">
            <input
                id="forAT_ResidentProfileTimeWindow_from"
                v-on-clickaway="hideDropDownFrom"
                :value="formatedFrom"
                :placeholder="$t('sensors.residentProfilesTab.fromPlaceholder')"
                :disabled="timesBy15from.length === 0"
                class="time-input"
                autocomplete="off"
                readonly
                @click.prevent="openFrom = !openFrom"
                @input="$emit('update', { option: 'time_window_from', value: $event.target.value })"
            />
            <i v-show="showLabels" class="icon-time"></i>
            <div v-show="openFrom" class="time-box">
                <simplebar class="with-border-track">
                    <ul>
                        <li
                            v-for="(row, index) in timesBy15from"
                            :key="index"
                            @click.prevent="$emit('update', { option: 'from', value: row.value })"
                        >
                            {{ formatTime(row.value) }}
                        </li>
                    </ul>
                </simplebar>
            </div>
        </div>
        <label>&mdash;</label>
        <div class="col-xs-4 time-wrapper">
            <input
                id="forAT_ResidentProfileTimeWindow_to"
                v-on-clickaway="hideDropDownTo"
                :value="formatedTo"
                :placeholder="$t('sensors.residentProfilesTab.toPlaceholder')"
                :disabled="timesBy15to.length === 0"
                class="time-input"
                autocomplete="off"
                readonly
                @click.prevent="openTo = !openTo"
                @input="emit('update', { option: 'time_window_to', value: $event.target.value })"
            />
            <i v-show="showLabels" class="icon-time"></i>
            <div v-show="openTo" class="time-box">
                <simplebar class="with-border-track">
                    <ul>
                        <li
                            v-for="(row, index) in timesBy15to"
                            :key="index"
                            @click.prevent="$emit('update', { option: 'to', value: row.value })"
                        >
                            {{ formatTime(row.value) }}
                        </li>
                    </ul>
                </simplebar>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import { mixin as clickaway } from 'vue-clickaway';
import simplebar from 'simplebar-vue';
import { formatTime } from './helpers';

export default {
    components: {
        simplebar,
    },

    mixins: [clickaway],

    props: {
        optionsStart: {
            required: false,
            type: Number,
            default: 0,
        },

        optionsEnd: {
            required: false,
            type: Number,
            default: 96,
        },

        showLabels: {
            type: Boolean,
            default: () => false,
        },

        value: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            openFrom: false,
            openTo: false,
        };
    },

    computed: {
        /**
         * Generates intervals by 15 minutes from start option to 'to' option from value(or till 24 hours)
         * @return {Array}
         */
        timesBy15from() {
            let res = [];
            let minutes = this.value.to ? this.value.to.replace('00:00', '24:00').split(':') : [];
            let end = minutes.length === 2 ? (minutes[0] * 60 + Number(minutes[1])) / 15 : 96;
            for (let i = this.optionsStart; i < end; i++) {
                let x =
                    (i < 40 ? '0' : '') +
                    Math.floor(i / 4) +
                    ':' +
                    (i % 4 ? (i % 2 ? ((i + 1) % 4 ? 15 : 45) : 30) : '00');

                res.push({ value: x });
            }
            return res;
        },

        /**
         * Generates intervals by 15 minutes from 'from' option from value or from 0 h to optionEnd
         * @return {Array}
         */
        timesBy15to() {
            let res = [];
            let minutes = this.value.from ? this.value.from.split(':') : [];
            let start =
                minutes.length === 2
                    ? (minutes[0] * 60 + Number(minutes[1])) / 15 + 1
                    : this.optionsStart + 1;
            for (let i = start; i <= this.optionsEnd; i++) {
                let x =
                    (i < 40 ? '0' : '') +
                    Math.floor(i / 4) +
                    ':' +
                    (i % 4 ? (i % 2 ? ((i + 1) % 4 ? 15 : 45) : 30) : '00');

                res.push({ value: x.replace('24:', '00:') });
            }
            return res;
        },

        formatedFrom() {
            return this.value.from ? formatTime(this.value.from) : undefined;
        },

        formatedTo() {
            return this.value.to ? formatTime(this.value.to) : undefined;
        },
    },

    watch: {
        '$route.path'() {
            // Hide time window drop down lists when going back/forward in history
            this.hideDropDownFrom();
            this.hideDropDownTo();
        },
    },

    methods: {
        formatTime,
        hideDropDownFrom() {
            this.openFrom = false;
        },

        hideDropDownTo() {
            this.openTo = false;
        },

        isFromValid() {
            return true;
        },
    },
};
</script>
